import styled from 'styled-components'
import { fontWeights, breakpoints, colors } from '@/styles'
import Skeleton from '@/components/skeleton'

const Wrapper = styled.div<{
  templateColumns: string
  gridColumns: string
  showBorder: boolean
  alignItems: string
}>`
  display: grid;
  grid-template-columns: ${props => (props.templateColumns ? props.templateColumns : '1fr 1fr')};
  grid-gap: 24px;
  align-items: ${props => (props.alignItems ? props.alignItems : 'flex-start')};
  width: 100%;
  ${props =>
    props.gridColumns &&
    `
    grid-column: ${props.gridColumns};
  `}
  ${props =>
    props.showBorder &&
    `
    border-bottom: 1px solid ${colors.grey88};
  `}
  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    margin: 0;
    padding: 12px;
    grid-column: 1 / 1;
  }
`

const Label = styled.span``

const Value = styled.span`
  justify-content: flex-start;
  font-weight: ${fontWeights.medium};
  text-align: left;
  max-width: 100%;
  overflow: auto;
  word-wrap: break-word;
`

type LabeledProps = {
  label: string | React.ReactNode
  value: string | React.ReactNode
  templateColumns?: string
  gridColumns?: string
  showBorder?: boolean
  alignItems?: string
  isLoading?: boolean
}

const LabeledValue: React.FC<LabeledProps> = ({
  label = '',
  value = '',
  templateColumns = '',
  gridColumns = '',
  showBorder = false,
  alignItems = 'flex-start',
  isLoading = false,
  ...rest
}) => (
  <Wrapper
    templateColumns={templateColumns}
    gridColumns={gridColumns}
    showBorder={showBorder}
    alignItems={alignItems}
    {...rest}
  >
    <Label>{label}</Label>
    <Value>{isLoading ? <Skeleton width="100%" height="100%" /> : value}</Value>
  </Wrapper>
)

export default LabeledValue
